"use strict";

var React = require('react');

var compose = require('../hoc/compose');

var displayNames = require('./displayNames');

var _require = require('../constants/classNames'),
    CONTEXT_MENU_WRAPPER_CLASS = _require.CONTEXT_MENU_WRAPPER_CLASS;

var ContextMenuContent = function ContextMenuContent(props) {
  return React.createElement('div', {
    className: props.getClassName(CONTEXT_MENU_WRAPPER_CLASS)
  }, props.children);
};

ContextMenuContent.displayName = displayNames.CONTEXT_MENU_CONTENT;
ContextMenuContent.propTypes = {};
module.exports = compose(ContextMenuContent);